<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<p style="text-align: center; font-size:14pt; padding-top:60px; padding-bottom:20px;">About the Author</p>
<p style="text-indent:0em;">Laurie Brady is a published poet, a writer of short stories, a novelist, and a great dog lover who lives in Sydney, Australia. He has a keen sense of humour, particularly a liking for the ridiculous, and a love of literature and sport. He has spent most of his working life as a teacher and a teacher educator, promoting engaging and quality schooling. He retired recently as professor of education at the University of Technology, Sydney.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?08e7e87e